<template>
  <div style="padding-top: 10px">
    <el-form :model="searchCondition" :inline="true" class="form" size="mini" label-width="80px">
      <el-form-item :label="''" class="search-item">
        <el-row :gutter="5">
          <el-col :span="24">
            <div style="margin-top:1px;min-width: 120px;display: inline">
              <el-select v-model="searchCondition.time_type" style="width: 110px;margin-right: 2px;margin-top: 1px"
                         @change="onSubmit"
                         clearable>
                <el-option value="transfer_time" label="回款时间"></el-option>
                <el-option value="claim_time" label="认领时间"></el-option>
                <el-option value="check_time" label="确认时间"></el-option>
              </el-select>
            </div>
            <div style="min-width: 300px;padding:0;display: inline;margin-left: 10px">
              <el-date-picker
                      v-model="timestampQuery"
                      type="daterange"
                      range-separator="至"
                      value-format="yyyy-MM-dd"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions"
                      style="width: 300px;margin-top: 2px;"
                      @change="timestampQueryChange"
              >
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item :label="'销\u3000\u3000售'" class="search-item">
        <PinYinMatchSelect :data="optionsMap.saleOption" :is-multiple="true"
                           :model-value.sync="searchCondition.sale_id"
                           @change="onSubmit" @focus="getOptionSales"/>
      </el-form-item>
      <el-form-item label="订单编号" class="search-item">
        <el-input v-model="searchCondition.order_no" placeholder="请输入订单编号"
                  @change="onSubmit" clearable/>
      </el-form-item>
      <el-form-item label-width="20px" style="text-align: right" class="search-item">
        <el-button type="primary" class="el-button--operation"
                   style="margin-left:10px;" @click="onSubmit">查询
        </el-button>
        <el-button @click="onReset" style="margin-right:10px;">重置</el-button>
        <!--        导出组件：导出功能和历史导出记录-->
        <account-export :search-condition="handleSearchCondition()" v-if="userAuth.ad_account_export"/>
      </el-form-item>
      <el-form-item style="float: right;" class="search-item">
        <el-checkbox v-model="searchCondition.hidden_fake" style="margin-left: 10px;" @change="onSubmit">隐藏虚拟回款记录</el-checkbox>
        <el-tooltip class="item" effect="dark" content="“虚拟回款记录”指全案营销项目订单下系统拆分或合成的回款记录" placement="top-start"
                    style="margin-left: 4px;">
          <el-button type="text" icon="el-icon-info" style="font-size: 14px;"/>
        </el-tooltip>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {saleOptions} from "@/api/user";
import {downloadAccount} from "@/api/account";
import AccountExport from "@/views/account/AccountExport";

export default {
  name: "AccountSearchForm",
  components: {AccountExport},
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  data() {
    return {
      //筛选条件
      timestampQuery: [],
      searchCondition: {time_type: 'claim_time', sale_id: [], order_no: null, hidden_fake: true},
      isMoreQueryShow: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          },
        ]
      },
      //下拉框数据
      optionsMap: {
        saleOption: [],
      },
    }
  },
  created() {
    this.defaultMonth()
  },
  mounted() {
  },
  methods: {
    defaultMonth() {
      //默认近6个月
      let currentDate = new Date()
      let currentMonth = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getDate()
      const start = new Date();
      start.setMonth(start.getMonth() - 1);
      let lastMonth = start.getFullYear() + '-' + (start.getMonth() + 1) + '-01'
      this.timestampQuery = [lastMonth, currentMonth]
      this.onSubmit()
    },
    onReset() {
      this.searchCondition = {};
    },
    onSubmit() {
      let searchCondition = this.handleSearchCondition()
      this.$emit('onSubmit', searchCondition)
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      //其他：单选字段
      let singleFields = ['order_no', 'sale_id', 'hidden_fake']
      singleFields.forEach((field) => {
        if (this.searchCondition[field] != null && this.searchCondition[field]) {
          condition[field] = this.searchCondition[field]
        }
      })

      //时间类型选择，解析其时间 3个
      if (this.searchCondition.time_type) {
        if (this.timestampQuery) {
          condition.time_type = this.searchCondition.time_type
          condition.start_time = this.timestampQuery[0]
          condition.end_time = this.timestampQuery[1]
        }
      }
      return condition
    },
    //下拉框数据加载
    //销售
    getOptionSales() {
      if (this.optionsMap.saleOption.length === 0) {
        saleOptions().then(res => {
          this.optionsMap.saleOption = res.model;
        });
      }
    },
    async downloadFile(row) {
      this.exportLoading = true
      row.download_count += 1
      const searchCondition = {id: row.id}

      try {
        let isFileSaverSupported = !!new Blob()
        if (isFileSaverSupported) {
          const response = await downloadAccount(searchCondition).then(response => {
            return response
          })
          this.exportLoading = false
          const data = response.data
          const contentType = response.headers['content-type']
          const name = `广告订单-回款记录`
          const blob = new Blob([data], {
            type: contentType
          })

          this.FileSaver.saveAs(blob, decodeURI(name + '.xlsx'), {autoBom: true})
        } else {
          this.$message.warning('浏览器不支持导出文件')
        }
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    timestampQueryChange() {
      this.searchCondition.begin_timestamp = this.timestampQuery ? this.timestampQuery[0] : ''
      this.searchCondition.end_timestamp = this.timestampQuery ? this.timestampQuery[1] : ''
      this.onSubmit()
    },
  }
}
</script>

<style scoped>
.search-item {
  margin-bottom: 5px !important;
}
</style>
